import { Link as _Link } from '@chakra-ui/react';
import { forwardRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const Link = _Link;

/**
 *
 * A Link for use when we don't need react-router. <strong>Do not use this if you are linking internally</strong>
 */
const CUILink = /*#__PURE__*/forwardRef((args, ref) => {
  return /*#__PURE__*/_jsx(Link, Object.assign({}, args, {
    ref: ref
  }));
});
export default CUILink;